module.exports = __webpack_public_path__ + "img/ws-lite.70b668f6.svg";